import { jsx as _jsx } from "react/jsx-runtime";
import { useResultCategoryOutletContext } from '@/components/results-category/hooks/use-result-category-outlet-context.hook';
import { resultCategoryImages, moderateCategory, } from '@/components/results-category/constants/results-category-content.constant';
import { HearingTestResult } from './hearing-results.component';
export function ModerateHearingLossResults() {
    useResultCategoryOutletContext({
        sideImage: resultCategoryImages.moderateHearingSideImage,
        step: 3,
    });
    return _jsx(HearingTestResult, { category: moderateCategory });
}
